<template>
  <div class="sidebar">
    <iscroll-view class="scroll-view" :options="{disableTouch: true, momentum: false, mouseWheel: true, scrollbars: true, fadeScrollbars: true, interactiveScrollbars: true, snap: true}" ref="iscroll">
      <div class="sidebar-wrap">
        <div class="code-dict-query">
          <span>
             <router-link :to="{name: 'CodeDictQuery'}" class="line">
               {{$t('query.result.other.codeDictQuery')}}
             </router-link>
          </span>
        </div>
        <RelatedPolicy class="list" />
        <RelatedNews class="list" />
      </div>
    </iscroll-view>
  </div>
</template>

<script>
import RelatedPolicy from './common/RelatedPolicy'
import RelatedNews from './common/RelatedNews'
export default {
  name: 'HsCodeSider',
  components: { RelatedPolicy, RelatedNews },
  methods: {
    refresh () {
      this.$refs.iscroll && this.$refs.iscroll.refresh()
    }
  }
}
</script>

<style scoped>
  .sidebar{
    overflow: hidden;
  }
  .scroll-view {
    /* -- Attention: This line is extremely important in chrome 55+! -- */
    touch-action: none;
    /* -- Attention-- */
    /*position: fixed;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  .sidebar-wrap{
    padding: 20px 18px;
  }
  .code-dict-query{
    padding-bottom: 20px;
    border-bottom: 1px solid #E9E9E9;
    /*font-size: 12px;*/
    font-size: 14px;
    /*font-weight: bold;*/
  }
  .code-dict-query span{
    /*background: url("~@/assets/images/icons/show/dict.png") 0 1px no-repeat transparent;*/
    background: url("~@/assets/images/icons/show/dict.png") 0 3px no-repeat transparent;
    background-size: 12px;
    padding-left: 18px;
  }
  .list{
    padding: 20px 0;
    border-bottom: 1px solid #E9E9E9;
  }
  .list:last-child{
    border-bottom: 0 none;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/query/HsCodeSider.vue